/**
 * MeetingMinutesService
 * Service for MeetingMinutes entity operations
 * Route: api/meetingminutes
 * Controller: MeetingMinutesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingMinutesService
 * Handles meeting minutes CRUD operations and custom endpoints
 * Maps to /api/meetingminutes endpoint
 */
export class MeetingMinutesService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingMinutesService.DEFAULT_SERVICE_PATH,
            basePath: MeetingMinutesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all minutes for a meeting
     * GET /api/meetingminutes/meeting/{meetingId}
     * @param meetingId - Meeting ID
     * @returns Array of meeting minutes
     */
    async getByMeeting(meetingId) {
        const response = await this.getByMeetingRaw(meetingId);
        return response.data ?? [];
    }
    getByMeetingRaw(meetingId) {
        const url = this.buildUrl('meeting/' + meetingId);
        return this.http.get(url);
    }
}
MeetingMinutesService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingMinutesService.BASE_PATH = 'api/meetingminutes';
//# sourceMappingURL=MeetingMinutesService.js.map